import React from 'react';
import { useIsMousePressed } from './useIsMousePressed';

export const usePreventFocusOnClick = () => {
  const isMousePressed = useIsMousePressed();
  return (event: React.FocusEvent) => {
    isMousePressed() && (event.target as HTMLElement).blur();
  };
};
